/* eslint-disable @typescript-eslint/no-unused-vars */
import { useModal } from '@/hooks/useModal';
import { useState } from 'react';

export const useSelectedItem = (data: any, setBoard: any) => {
  const { handleChange, open } = useModal();

  const [selectedItems, setSelectedItems] = useState<{
    name: string;
    quantity: number;
    idProduct: string;
    idColumn: string;
    idCard: string;
  }>({
    name: '',
    quantity: 0,
    idProduct: '',
    idColumn: '',
    idCard: '',
  });

  const changeItemSelect = (idCard: string, idColumn: string) => {
    const { cards } = data;
    setSelectedItems({
      name: cards[idCard].name,
      quantity: cards[idCard].quantity,
      idProduct: cards[idCard].idProduct,
      idColumn,
      idCard,
    });
    handleChange();
  };

  const divideItem = (cards: any, item: any, quantity: number) => {
    const randomId = `new-${new Date().getTime().toString()}`;
    const quantityNew = item.quantity - quantity;
    const priceUnit = item.price / item.quantity;

    return {
      cards: {
        ...cards,
        [item.id]: {
          ...item,
          quantity: quantityNew,
          price: priceUnit * quantityNew,
        },
        [randomId]: {
          id: randomId,
          name: selectedItems.name,
          quantity,
          price: priceUnit * quantity,
          idProduct: selectedItems.idProduct,
          parentId: item.id,
        },
      },
      randomId,
    };
  };

  const onDivideItems = (quantity: number) => {
    const { cards, randomId } = divideItem(data.cards, data.cards[selectedItems.idCard], quantity);

    setBoard((prev: any) => ({
      ...prev,
      cards,
      columns: {
        ...prev.columns,
        [selectedItems.idColumn]: {
          ...prev.columns[selectedItems.idColumn],
          cardIds: [...prev.columns[selectedItems.idColumn].cardIds, randomId],
        },
      },
    }));
    handleChange();
  };

  const onReload = (idCard: string, columnId: string) => {
    const newCard = data.cards[idCard];
    const oldCard = data.cards[newCard.parentId];
    const cardsIds = data.columns[columnId].cardIds;
    cardsIds.splice(cardsIds.indexOf(idCard), 1);
    const quantityNew = newCard.quantity + oldCard.quantity;
    const priceUnit = newCard.price / newCard.quantity;
    const { [idCard]: removeCard, ...restCards } = data.cards;

    setBoard((prev: any) => ({
      ...prev,
      cards: {
        ...restCards,
        [newCard.parentId]: {
          ...oldCard,
          quantity: quantityNew,
          price: quantityNew * priceUnit,
        },
      },
      columns: {
        ...prev.columns,
        [columnId]: {
          ...prev.columns[selectedItems.idColumn],
          cardIds: cardsIds,
        },
      },
    }));
  };

  return { selectedItems, changeItemSelect, handleChange, onDivideItems, onReload, open };
};
